export enum ValidSizeUpdateTypes {

    propertyUpdated = 'PROPERTY_UPDATED',
    selectionLayoutConfigUpdated = 'SELECTION_LAYOUT_CONFIG_UPDATED',
    layoutConfigUpdated = 'LAYOUT_CONFIG_UPDATED'

}
